import * as axios from "axios";
import Api from "./Api";

export default class ReportService extends Api {

    private _endpoint = "/Report";

    public async getMasterParticipatingBusOperatorReport(): Promise<Blob> {
        return super
        .init()
        .get<Blob>(`${this._endpoint}/GetMasterParticipatingBusOperatorReport`)
        .then((response) => {
          return response.data;
        })
        .catch((error: axios.AxiosError) => {
          return new Blob();
        });
    }

    public async getNaptanAllZonesReport(): Promise<Blob> {
      return super
      .init()
      .get<Blob>(`${this._endpoint}/GetNaptanAllZonesReport`)
      .then((response) => {
        return response.data;
      })
      .catch((error: axios.AxiosError) => {
        return new Blob();
      });     
  }


  public async getNaptanWithinAZoneReport(farezoneId:string): Promise<Blob> {
    return super
    .init()
    .get<Blob>(`${this._endpoint}/GetNaptanWithinAZoneReport?farezoneId=${farezoneId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error: axios.AxiosError) => {
      return new Blob();
    });
  }
}